import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { AbsProduct } from '@/creditflowresearch/domain/Product';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import {
  getProductGradient,
  findMatchingCombination,
  prioritizeProductAbbreviations,
} from '@/creditflowresearch/ui/common/utils/products/productStyleHelpers';
import { parseQueryParamValue } from '@/creditflowresearch/ui/common/utils/query/parseQueryParams';

const DEFAULT_GRADIENT = getProductGradient(AbsProduct.ABBREVIATION);

export const useProductGradient = (product?: IProduct['abbreviation']): string => {
  const { query } = useRouter();
  const productAbbreviationsFromQuery = parseQueryParamValue(query.products || product);

  return useMemo(() => {
    if (productAbbreviationsFromQuery.length === 0) {
      return DEFAULT_GRADIENT;
    }

    const abbreviations = productAbbreviationsFromQuery as string[];
    const filteredAbbreviations = prioritizeProductAbbreviations(abbreviations);
    const matchingCombination = findMatchingCombination(filteredAbbreviations);

    if (matchingCombination) {
      return getProductGradient(matchingCombination.gradientKey);
    }

    return getProductGradient(filteredAbbreviations[0]);
  }, [productAbbreviationsFromQuery]);
};
